import { DocumentNode } from 'graphql';
import {
  gql, QueryHookOptions, useLazyQuery, useQuery,
} from '@apollo/client';
import { IPlanSchemaPartial, IPlanSchema } from '../../type/plan';
import { IWithPagination, DeepPartial } from '../_module/baseQueryType';



export interface IPlanVars {
  
 filter: {
  _id?: string;
  _ids?: string[];
  status?: boolean;
  companyId?: string;

  subscriptionPackageID?: string;
}
 sort: {
  _id?: number;
  subscriptionPackageID?: number;
  subscriptionExpiryDate?: number;
  createdTime?: number;
}
 search: {
  _id?: string;
  companyName?: string;
  companyId?: string;
}
 skip?: number
 limit?: number
 
  
  
  
  
 
}
export const PlanQueryTypeDefinitionKey = 'Plan';
export type IPlanVarsPartial = Partial<IPlanVars>
export type IPlanDataPartial = DeepPartial<IPlanSchemaPartial>
export interface IPlanQueryData<TData extends IPlanSchema = IPlanSchema>{
  

    plans: IWithPagination<TData>
}

export function planQuery(fragment: string, rootFragment?: string, withPagination?: boolean): DocumentNode {
  return gql`
        query 

    plans(
        $filter: PlanQueryFilterParameterInput,
$search: PlanQuerySearchParameterInput,
$sort: PlanQuerySortParameterInput,
$skip: Int,
$limit: Int
        ){
        

    plans(
        filter: $filter,
search: $search,
sort: $sort,
skip: $skip,
limit: $limit
        ){
          items {
              ${fragment}
          }
          ${withPagination ? `
          pagination {
            total
            perPage
            currentPage
            hasNextPage
            totalPage
          }
          ` : ''}
          ${rootFragment || ''}
        }
        }
    `;
}

export function usePlanLazyQuery<TData extends IPlanSchema>(
  fragment: string,
  options?: QueryHookOptions<IPlanQueryData<TData>, IPlanVarsPartial>,
  rootFragment?: string,
  withPagination?: boolean
) {
  return useLazyQuery<IPlanQueryData<TData>, IPlanVarsPartial>(planQuery(fragment, rootFragment, withPagination), options);
}

export function usePlanQuery<TData extends IPlanSchema>(
  fragment: string,
  options?: QueryHookOptions<IPlanQueryData<TData>, IPlanVarsPartial>,
  rootFragment?: string,
  withPagination?: boolean
) {
  return useQuery<IPlanQueryData<TData>, IPlanVarsPartial>(planQuery(fragment, rootFragment, withPagination), options);
}
